import React, { useState } from "react"
import { Grid } from "@material-ui/core"

import { ActionDialog } from "@/components"
import MessageItem from "@/components/ChatMessageBuilder/MessageItem"
import { Variable } from "@/components/ChatMessageBuilder/VariableInput"

import { WABAChannelMessageTemplate, WABATemplateVariableIndexToVariableName, WABATemplateVariableMapping } from "@/@integrations/WABA/protocols/wabaChannelMessageTemplate"
import WABATemplateVariableMappingForm from "@/@integrations/WABA/components/Chat/WABAMessageTemplate/WABATemplateVariableMappingForm"

type WABATemplateVariableMappingDialogProps = {
	template: WABAChannelMessageTemplate
	unmappedIndices: string[]
	unmappedBySection: Record<keyof WABATemplateVariableMapping, string[]>
	availableVariables: Variable[]
	title: string
	saveText: string
	onSave: (selectedVariableByIndex: WABATemplateVariableIndexToVariableName) => Promise<void>
	onClose?: () => void
}

const WABATemplateVariableMappingDialog: React.FC<WABATemplateVariableMappingDialogProps> = (props) => {
	const {
		template,
		unmappedIndices,
		availableVariables,
		title,
		saveText,
		onSave,
		onClose
	} = props

	const [selectedVariableByIndex, setSelectedVariableByIndex] = useState<WABATemplateVariableIndexToVariableName>({})

	const allVariablesMapped = unmappedIndices.every(variableIndex => Boolean(selectedVariableByIndex[variableIndex]))

	const handleSave = async () => {
		await onSave(selectedVariableByIndex)
	}

	return (
		<ActionDialog
			title={title}
			openDialog
			cancelText="CANCELAR"
			saveText={saveText}
			saveButtonDisabled={!allVariablesMapped}
			fullWidth
			forcedRender
			onSave={handleSave}
			onClose={onClose}
		>
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<MessageItem
						copySpecial={false}
						type={template.message.type}
						content={template.message.content}
						mediaName={template.message.mediaName}
						extraData={template.message.extraData}
						style={{ width: "100%" }}
					/>
				</Grid>

				<Grid item xs={12}>
					<WABATemplateVariableMappingForm
						unmappedVariableIndices={unmappedIndices}
						availableVariables={availableVariables}
						onMappingChange={setSelectedVariableByIndex}
					/>
				</Grid>
			</Grid>
		</ActionDialog>
	)
}

export default WABATemplateVariableMappingDialog
